import React from 'react';
import { BringzzButton, BringzzText } from '@bringzz/components';
import { useNavigation } from '../../context/NavigationContext';
import { useTranslation } from 'react-i18next';
import basketImage from '../../assets/images/basket.png';

const EmptyBasketState = () => {
    const { navigate } = useNavigation();
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 bg-[#F5F1E8]">
            <div className="mb-6">
                <img src={basketImage} alt="Empty basket" className="w-32 h-32" />
            </div>

            <BringzzText tag="h2" className="text-xl font-semibold text-gray-800 mb-2 text-center">
                {t('component.basket.empty_state.title', 'Your basket is currently empty.')}
            </BringzzText>
            <BringzzText className="text-sm text-gray-500 mb-8 text-center">
                {t('component.basket.empty_state.subtitle', 'When you add products, they\'ll appear here.')}
            </BringzzText>

            <div className="w-full max-w-sm space-y-3">
                <BringzzButton
                    className="w-full bg-purple-600 text-white rounded-full py-3 font-semibold"
                    onClick={() => navigate('/search')}
                >
                    {t('component.basket.empty_state.search_products', 'Search for products')}
                </BringzzButton>

                <BringzzButton
                    className="w-full border border-black text-black rounded-full py-3 font-semibold"
                    onClick={() => navigate('/home')}
                >
                    {t('component.basket.empty_state.go_home', 'Go to Home')}
                </BringzzButton>

                <BringzzButton
                    className="w-full bg-[#F5FF88] text-black rounded-full py-3 font-semibold"
                    onClick={() => navigate('/scan')}
                >
                    {t('component.basket.empty_state.scan_prescription', 'Scan your prescription')}
                </BringzzButton>
            </div>
        </div>
    );
};

export default EmptyBasketState;
